import { useState } from "react";
import { useReportAccidentQuery } from "../reportRoadAccidents/hooks/useReportAccidentQuery";
import { useLegalProvisionDocumentCommand } from "./hooks/useLegalProvisionDocumentCommand";
import SelectSearch from "../../common/components/SelectSearch";
import Button from "../../common/components/Button";

function RegisterDocuments() {
  const {
    legalProvisionDocument,
    handleChangeLegalProvisionDocument,
    errors,
    createLegalProvisionDocument,
    loading,
  } = useLegalProvisionDocumentCommand();
  const [search, setSearch] = useState(legalProvisionDocument.accident || "");
  const { reportAccidents } = useReportAccidentQuery({ search, limit: 10 });

  const handleChangeFile = (file) => {
    if (file) {
      handleChangeLegalProvisionDocument({
        name: "files",
        value: [...legalProvisionDocument.files, file],
      });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    createLegalProvisionDocument(legalProvisionDocument);
  };

  return (
    <main className="container p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">
          Registrar documentos de provisiones legales
        </h1>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3">
          <div className="w-100">
            <p>
              Formulario de registro de provisiones legales relacionados con
              siniestros.
            </p>

            <form onSubmit={handleSubmit} className="d-flex flex-column gap-3">
              <SelectSearch
                name="accident"
                label="Siniestros"
                placeholder="Selecciona un siniestro"
                options={reportAccidents.map((accident) => ({
                  value: accident.id,
                  label: `${accident.dateAccident} - ${accident.id} - ${accident.namePersonInvolved} - ${accident.vehiclePlate}`,
                }))}
                value={legalProvisionDocument.accident}
                onSelect={handleChangeLegalProvisionDocument}
                onSearch={(text) => setSearch(text)}
                error={errors.errors.accident}
              />

              <div className="row row-cols-1 row-cols-md-4 g-3">
                {Array.from({
                  length: legalProvisionDocument.files.length + 1,
                }).map((_, index) => (
                  <div className=" mb-3" key={index}>
                    <div className="form-group">
                      <label
                        htmlFor={`fileInput-${index}`}
                        className="form-label fw-semibold"
                      >
                        Documento {index + 1}
                      </label>
                      <input
                        type="file"
                        id={`fileInput-${index}`}
                        className={`form-control ${
                          errors.errors.files ? "is-invalid" : ""
                        }`}
                        onChange={(e) =>
                          handleChangeFile(e.target.files[0] || null)
                        }
                      />
                      {errors.errors.files && (
                        <div className="invalid-feedback">
                          {errors.errors.files}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <Button type="submit" loading={loading}>
                Registrar Documento
              </Button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}

export default RegisterDocuments;
